'use strict'
import axios from 'axios'
import store from '@/stores'
import router from '@/router'
import { getCookie, setCookie, removeCookie } from '@/utils/auth'
const httpConfig = require('./env.config')
const reject = (err) => {
  return Promise.reject(err)
}
// request interceptors 请求拦截
axios.interceptors.request.use(config => {
  config.baseURL = httpConfig.iot
  config.headers.post['Content-Type'] = 'application/json; charset=utf-8'
  config.headers['session'] = getCookie('iot-session') || ''
  config.headers['ip_origin'] = window.returnCitySN && window.returnCitySN['cip'] ? window.returnCitySN['cip'] : ''
  config.timeout = 60 * 1000 // 请求超时时长设为60s
  config.auth = {
    username: 'yKQaLlj74zk',
    password: 'd7604c2f6e4cedc9'
  }
  return config
}, err => {
  return reject(err)
})

// response interceptors 响应拦截
axios.interceptors.response.use(response => {
  // 响应正常返回
  return response
}, error => {
  // 响应异常捕获
  if (error.response) {
    if (error.response.status && (error.response.status === 411 || error.response.status === 401)) {
      store.dispatch('logOut', {}).then(() => {
        router.replace({ path: '/' })
        ELEMENT.Message({
          message: '登录过期',
          type: 'error'
        })
      })
    }
    return Promise.reject(error.response)
  } else if (error.request) {
    if (error.request.readyState === 4 && error.request.status === 0) {
      ELEMENT.Message({
        message: '请求超时，请稍后重试',
        type: 'error'
      })
    }
    return Promise.reject(error.request)
  } else {
    return Promise.reject(error)
  }
})

function get_pk () {
  return new Promise((resolve, reject) => {
    axios({
      url: `/v5/r/pk`,
      method: 'GET'
    }).then(res => {
      if (res.data.pk && res.data.fm_sn) {
        setCookie('pk', res.data.pk)
        setCookie('pk-sn', res.data.fm_sn)
        resolve(true)
      } else {
        reject(res)
      }
    }).catch(err => {
      reject(err)
    })
  })
}
// 不使用pk公钥封装请求url的请求方法
const get = (url, params) => {
  return axios({
    url,
    method: 'GET',
    params
  }).then(res => {
    return res
  }).catch(err => {
    return reject(err)
  })
}
const post = (url, data) => {
  return axios({
    url,
    method: 'POST',
    data
  }).then(res => {
    return res
  }).catch(err => {
    return reject(err)
  })
}
const put = (url, data) => {
  return axios({
    method: 'put',
    url,
    data
  }).then(res => {
    return res
  }).catch(err => {
    return reject(err)
  })
}
//  使用pk公钥封装请求url的方法
const iot_get = (url, params = {}, encryptKeys = []) => {
  return new Promise((resolve, reject) => {
    if (getCookie('pk')) { // 存在pk，执行请求，不存在pk，请求pk
      resolve(do_request())
    } else {
      get_pk().then(res => {
        if (res) {
          resolve(do_request())
        }
      }).catch(err => {
        reject(err)
      })
    }
  })
  function do_request () {
    let encrypt = new JSEncrypt()
    encrypt.setPublicKey(getCookie('pk'))
    let fmMagic = encrypt.encrypt(url)
    fmMagic = fmMagic.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
    let fmSn = getCookie('pk-sn')
    let requestParams = {}
    Object.keys(params).forEach(key => { // 使用formData作为传递数据
      requestParams[key] = params[key]
    })
    // 遍历需要加密的key
    encryptKeys.map(key => {
      requestParams[key] = encrypt.encrypt(requestParams[key]).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
    })
    // console.log(url, 'get', 'params', requestParams)
    let dataTo = {
      url: `/v5/r?fm_magic=${fmMagic}&fm_sn=${fmSn}`,
      method: 'GET',
      params: requestParams
    }
    return axios(dataTo).then(res => {
      return res
    }).catch(err => {
      if (err.data && err.data.status_code && err.data.status_code == 40901) { // 公钥过期
        // 清除原有公钥
        removeCookie('pk')
        removeCookie('pk-sn')
        // 重新执行请求
        return new Promise((resolve, reject) => {
          iot_get(url, params, encryptKeys).then(res => {
            resolve(res)
          }).catch(err => {
            reject(err)
          })
        })
      }
      return reject(err)
    })
  }
}
const iot_post = (url, data = {}, encryptKeys = []) => { // encryptKeys 需要加密的key，不是所有的Key都需要加密
  return new Promise((resolve, reject) => {
    if (getCookie('pk')) { // 存在pk，执行请求，不存在pk，请求pk
      resolve(do_request())
    } else {
      get_pk().then(res => {
        if (res) {
          resolve(do_request())
        }
      }).catch(err => {
        reject(err)
      })
    }
  })
  function do_request () {
    let encrypt = new JSEncrypt()
    encrypt.setPublicKey(getCookie('pk'))
    let fmMagic = encrypt.encrypt(url) // 格式化URL
    fmMagic = fmMagic.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
    let fmSn = getCookie('pk-sn')
    let requestData = {}
    Object.keys(data).forEach(key => { // 使用formData作为传递数据
      requestData[key] = data[key]
    })
    // 遍历需要加密的key
    encryptKeys.map(key => {
      requestData[key] = encrypt.encrypt(requestData[key]).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
    })
    console.log(url, 'post', 'data', requestData)
    let dataTo = {
      url: `/v5/r?fm_magic=${fmMagic}&fm_sn=${fmSn}`,
      method: 'POST',
      data: requestData
    }
    return axios(dataTo).then(res => {
      return res
    }).catch(err => {
      if (err.data && err.data.status_code && err.data.status_code == 40901) { // 公钥过期
        removeCookie('pk') // 清除原有公钥
        removeCookie('pk-sn')
        return new Promise((resolve, reject) => { // 重新执行请求
          iot_post(url, data, encryptKeys).then(res => {
            resolve(res)
          }).catch(err => {
            reject(err)
          })
        })
      }
      return reject(err)
    })
  }
}
const iot_put = (url, data = {}, encryptKeys = []) => {
  return new Promise((resolve, reject) => {
    if (getCookie('pk')) { // 存在pk，执行请求，不存在pk，请求pk
      resolve(do_request())
    } else {
      get_pk().then(res => {
        if (res) {
          resolve(do_request())
        }
      }).catch(err => {
        reject(err)
      })
    }
  })
  function do_request () {
    let encrypt = new JSEncrypt()
    encrypt.setPublicKey(getCookie('pk'))
    let fmMagic = encrypt.encrypt(url) // 格式化URL
    fmMagic = fmMagic.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
    let fmSn = getCookie('pk-sn')
    let requestData = {} // 格式化post请求body
    Object.keys(data).forEach(key => { // 使用formData作为传递数据
      requestData[key] = data[key]
    })
    // 遍历需要加密的key
    encryptKeys.map(key => {
      requestData[key] = encrypt.encrypt(requestData[key]).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
    })
    console.log(url, 'put', 'data', requestData)
    let dataTo = {
      url: `/v5/r?fm_magic=${fmMagic}&fm_sn=${fmSn}`,
      method: 'PUT',
      data: requestData
    }
    return axios(dataTo).then(res => {
      return res
    }).catch(err => {
      // 判断当前错误是否是 pk 公钥过期
      if (err.data && err.data.status_code && err.data.status_code == 40901) { // 公钥过期
        // 清除原有公钥
        removeCookie('pk')
        removeCookie('pk-sn')
        // 重新执行请求
        return new Promise((resolve, reject) => {
          iot_put(url, data, encryptKeys).then(res => {
            resolve(res)
          }).catch(err => {
            reject(err)
          })
        })
      }
      return reject(err)
    })
  }
}
// delete请求url携带参数 , 传递的参数默认为url携带的参数
const iot_delete = (url, params = {}, encryptKeys = []) => {
  return new Promise((resolve, reject) => {
    if (getCookie('pk')) { // 存在pk，执行请求，不存在pk，请求pk
      resolve(do_request())
    } else {
      get_pk().then(res => {
        if (res) {
          resolve(do_request())
        }
      }).catch(err => {
        reject(err)
      })
    }
  })
  function do_request () {
    let encrypt = new JSEncrypt()
    encrypt.setPublicKey(getCookie('pk'))
    let fmMagic = encrypt.encrypt(url) // 格式化URL
    fmMagic = fmMagic.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
    let fmSn = getCookie('pk-sn')
    let requestParams = {}
    Object.keys(params).forEach(key => { // 使用requestParams 重新组合参数
      requestParams[key] = params[key]
    })
    // 遍历需要加密的key
    encryptKeys.map(key => {
      requestParams[key] = encrypt.encrypt(requestParams[key]).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
    })
    console.log(url, 'delete', 'params', requestParams)
    let dataTo = {
      url: `/v5/r?fm_magic=${fmMagic}&fm_sn=${fmSn}`,
      method: 'DELETE',
      params: requestParams
    }
    return axios(dataTo).then(res => {
      return res
    }).catch(err => {
      // 判断当前错误是否是 pk 公钥过期
      if (err.data && err.data.status_code && err.data.status_code == 40901) { // 公钥过期
        // 清除原有公钥
        removeCookie('pk')
        removeCookie('pk-sn')
        // 重新执行请求
        return new Promise((resolve, reject) => {
          iot_delete(url, params, encryptKeys).then(res => {
            resolve(res)
          }).catch(err => {
            reject(err)
          })
        })
      }
      return reject(err)
    })
  }
}
const community = (url, method = 'get', params = {}, data = {}, headers = {}, encryptKeys = []) => {
  return new Promise((resolve, reject) => {
    if (getCookie('pk')) { // 存在pk，执行请求，不存在pk，请求pk
      resolve(do_request())
    } else {
      get_pk().then(res => {
        if (res) {
          resolve(do_request())
        }
      }).catch(err => {
        reject(err)
      })
    }
  })
  function do_request () {
    axios.defaults.headers['session'] = getCookie('iot-session') || ''
    axios.defaults.baseURL = httpConfig.iot
    axios.defaults.auth = {
      username: '',
      password: ''
    }
    let formatUrl = '/community/v2' + url
    console.log(formatUrl, method)
    let encrypt = new JSEncrypt()
    encrypt.setPublicKey(getCookie('pk'))
    let fmMagic = encrypt.encrypt(formatUrl) // 格式化URL
    fmMagic = fmMagic.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
    let fmSn = getCookie('pk-sn')
    let dataTo = {
      url: `/v5/r?fm_magic=${fmMagic}&fm_sn=${fmSn}`,
      method,
      params,
      headers
    }
    let requestData = {}
    Object.keys(data).forEach(key => { // 使用formData作为传递数据
      requestData[key] = data[key]
    })
    // 遍历需要加密的key
    encryptKeys.map(key => {
      requestData[key] = encrypt.encrypt(requestData[key]).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
    })
    if (method !== 'delete') {
      dataTo['data'] = requestData
    }
    return axios(dataTo).then(res => {
      return res
    }).catch(err => {
      // 判断当前错误是否是 pk 公钥过期
      if (err.data && err.data.status_code && err.data.status_code == 40901) { // 公钥过期
        // 清除原有公钥
        removeCookie('pk')
        removeCookie('pk-sn')
        // 重新执行请求
        return new Promise((resolve, reject) => {
          community(url, method, params, data, headers, encryptKeys).then(res => {
            resolve(res)
          }).catch(err => {
            reject(err)
          })
        })
      }
      axios.defaults.headers['session'] = getCookie('iot-session') || ''
      axios.defaults.baseURL = httpConfig.host
      axios.defaults.auth = {
        username: 'yKQaLlj74zk',
        password: 'd7604c2f6e4cedc9'
      }
      return reject(err)
    })
  }
}

export default {
  get,
  post,
  put,
  iot_get,
  iot_post,
  iot_put,
  iot_delete,
  community
}



// WEBPACK FOOTER //
// ./src/utils/http.js